<template>

  <el-table-column :prop="params" :width="width" show-overflow-tooltip>
    <template slot="header">
      <div  style="display:flex;align-items: center;" >
        <span>{{title}}</span>
        <div @click="toggleSensitiveInfo" class="itemEye" v-if="hasPermission(893)">
           <img :id="idName3"  src="../../assets/bybk.png" style="width:20px;height:11px;"/>
           <img class="byk" :id="idName4" src="../../assets/zyk.png" style="width:20px;height:14px;"/>
        </div>
      </div>
    </template>
    <template slot-scope="scope">
        <span v-if="type=='phoneNumber'"> {{ formatPhoneNumber(scope.row[params]) }}</span>
        <span v-if="type=='idCard'">{{ formatIDCard(scope.row[params]) }}</span>
        <span v-if="type=='name'">{{ formatName(scope.row[params]) }}</span>
        <span v-if="type=='operator'"> {{ formatOperator(scope.row[params]) }}</span>
    </template>
  </el-table-column>

</template>
<style scoped lang="scss">

.itemEye{
    // display: inline-block;
    display: flex;
    height: 16px;
    margin-left: 2px;
    cursor: pointer;
    color: #575B6C;
    align-items: center; /* 垂直居中 */
 
    &:hover{
        color: #0066FF!important;
    }
}
.byk{
  display: none;
}
</style>

<script>
import {generateRandomAlphaNumeric} from '@/utils/index'
export default {
    data(){
        
        return {
            show:false
        }
    },
  props: {
    params: {
      default() {
        return "operatorName";       
      },
    },
    type:{
        default() {
         return "operator";       
      },
    },
    title:{
      default() {
        return "所属运营商";       
      },
    },
    idName3:{
        default() {
             
           const result = generateRandomAlphaNumeric(4)
           return result;       
        },
    },
    idName4:{
        default() {

          const result = generateRandomAlphaNumeric(4)
          return result;       
        },
    },
    width:{
      type:String,
      default:'150'
    },
  
  },
  methods: {
    
    toggleSensitiveInfo(){

        this.show=!this.show
        if(this.show){
                $("#"+this.idName3).hide();
                $("#"+this.idName4).show();
        }else{
                $("#"+this.idName3).show();
                $("#"+this.idName4).hide()
        }
    },
    formatPhoneNumber(number) {
        
        if(this.show){
            return number
        }else{
            if(number){
                const regex = /^(\d{3})\d+(\d{4})$/;
                return number.replace(regex, '$1****$2');
            }   
             return number
            
        }
      
    },
    formatIDCard(idCard) {

        if(this.show){
            return idCard
        }else{
            if(idCard){
                const regex = /^(.{6}).+(.{4})$/;
                return idCard.replace(regex, '$1********$2');
            }
            return idCard
            
        }

      
    },
    formatName(name) {
        if(this.show){
            return name
        }else{
            if(name){
                if (name.length === 2) {
                    return `${name[0]}*`;
                } else if (name.length === 3) {
                    return `${name[0]}*${name[2]}`;
                } else if (name.length > 3) {
                    return `${name[0]}${'*'.repeat(name.length - 2)}${name[name.length - 1]}`;
                }
            }
            return name
            
            
        }
      
    },

    formatOperator(operator) {
         if(this.show){
            return operator
        }else{
            if(operator){
                return `${operator[0]}${'*'.repeat(operator.length - 1)}`;
            }
            return operator
            
        }
      
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SensitiveInfo/index.vue